<ideal-cart-item-result-list [ids]="ids()" />
